<template>
  <div class="act_layout">
    <div class="container_compact_panel">
      <div class="container_compact_row container_size_row" data-guide="container-size-control">
        <span class="compact_label">大小</span>
      <van-slider
        class="size_slider"
        v-model="size"
        @input="handleInput"
        :min="0.1"
        :max="3"
        :step="0.05"
        bar-height="4px"
        inactive-color="#999"
        active-color="#6e9f21"
      />
        <button
          type="button"
          class="compact_btn light_toggle"
          :class="{ active: lightEnabled }"
          data-guide="container-light-control"
          @click="toggleLight"
        >
          光感
        </button>
        <button type="button" class="compact_btn container_delete" @click="remove">删除</button>
      </div>
      <div class="container_compact_row studio_container_tools" v-if="isStudioMode && id">
        <span class="compact_label">位置</span>
        <div class="container_button_group">
          <button type="button" class="compact_btn" @click="moveContainer(0, moveStep)">上</button>
          <button type="button" class="compact_btn" @click="moveContainer(-moveStep, 0)">左</button>
          <button type="button" class="compact_btn" @click="moveContainer(moveStep, 0)">右</button>
          <button type="button" class="compact_btn" @click="moveContainer(0, -moveStep)">下</button>
        </div>
        <span class="compact_label shadow_label">阴影</span>
        <button type="button" class="compact_btn" @click="rotateShadow(-15)">左旋</button>
        <button type="button" class="compact_btn" @click="rotateShadow(15)">右旋</button>
        <van-slider
          class="shadow_slider"
          v-model="shadowIntensity"
          @input="emitContainerShadow"
          :min="0"
          :max="125"
          :step="1"
          bar-height="3px"
          inactive-color="#d7ddcf"
          active-color="#6e9f21"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      size: 1,
      id: "",
      lightEnabled: false,
      moveStep: 5,
      containerPosition: { x: 0, y: 0, z: 0 },
      shadowIntensity: 78,
      shadowDirection: 92,
    };
  },
  computed: {
    isStudioMode() {
      return this.$store.state.routeParams.editorType === "studio";
    },
  },
  methods: {
    handleInput() {
      this.$bus.$emit("guide-control-change", {
        key: "containerSize",
      });
      this.$bus.$emit("setSize", {
        id: this.id,
        value: this.size,
      });
    },
    remove() {
      this.$bus.$emit("remove", this.id);
    },
    handleLightChange() {
      this.$bus.$emit("guide-control-change", {
        key: "containerLight",
      });
      this.$bus.$emit("setContainerLight", this.lightEnabled);
    },
    toggleLight() {
      this.lightEnabled = !this.lightEnabled;
      this.handleLightChange();
    },
    normalizePosition(position = {}) {
      const pickNumber = (value, fallback = 0) => {
        const numberValue = parseFloat(value);
        return Number.isNaN(numberValue) ? fallback : numberValue;
      };
      return {
        x: pickNumber(position.x),
        y: pickNumber(position.y),
        z: pickNumber(position.z),
      };
    },
    normalizeShadow(shadow = {}) {
      const rawIntensity = shadow.intensity !== undefined ? shadow.intensity : shadow.opacity;
      let intensity = parseFloat(rawIntensity);
      let direction = parseFloat(shadow.direction);
      if (Number.isNaN(intensity)) {
        intensity = 0.78;
      }
      if (Number.isNaN(direction)) {
        direction = 92;
      }
      direction %= 360;
      if (direction < 0) {
        direction += 360;
      }
      return {
        intensity: Math.max(0, Math.min(1.25, intensity)),
        direction,
      };
    },
    moveContainer(deltaX, deltaY) {
      if (!this.id) {
        return;
      }
      this.containerPosition = {
        ...this.containerPosition,
        x: this.containerPosition.x + deltaX,
        y: this.containerPosition.y + deltaY,
      };
      this.$bus.$emit("setContainerPosition", {
        id: this.id,
        ...this.containerPosition,
      });
    },
    rotateShadow(delta) {
      if (!this.id) {
        return;
      }
      this.shadowDirection = (this.shadowDirection + delta) % 360;
      if (this.shadowDirection < 0) {
        this.shadowDirection += 360;
      }
      this.emitContainerShadow();
    },
    emitContainerShadow() {
      if (!this.id) {
        return;
      }
      this.$bus.$emit("setContainerShadow", {
        id: this.id,
        intensity: this.shadowIntensity / 100,
        direction: this.shadowDirection,
      });
    },
    syncContainer(val) {
      if (!val) {
        this.id = "";
        this.size = 1;
        this.lightEnabled = false;
        this.containerPosition = { x: 0, y: 0, z: 0 };
        this.shadowIntensity = 78;
        this.shadowDirection = 92;
        return;
      }
      const params = val.params || {};
      const shadow = this.normalizeShadow(params.shadow || val.shadow);
      this.id = val.id;
      this.size = params.size || 1;
      this.lightEnabled = !!val.containerLight;
      this.containerPosition = this.normalizePosition(params.position || val.position);
      this.shadowIntensity = Math.round(shadow.intensity * 100);
      this.shadowDirection = shadow.direction;
    },
  },
  mounted() {
    this.$bus.$on("container-add", this.syncContainer);
    this.$bus.$on("container-select", this.syncContainer);
  },
  beforeDestroy() {
    this.$bus.$off("container-add", this.syncContainer);
    this.$bus.$off("container-select", this.syncContainer);
  },
};
</script>
<style lang="scss" scoped>
.act_layout {
  padding-top: 0;
}

.container_compact_panel {
  width: 100%;
  box-sizing: border-box;
}

.container_compact_row {
  display: flex;
  align-items: center;
  min-width: 0;
  gap: rem(8);
}

.container_compact_row + .container_compact_row {
  margin-top: rem(6);
}

.compact_label {
  flex: 0 0 auto;
  color: #596156;
  font-size: rem(21);
  font-weight: bold;
  white-space: nowrap;
}

.size_slider {
  flex: 1 1 auto;
  min-width: rem(130);
  margin: 0 rem(4);
}

.compact_btn {
  flex: 0 0 auto;
  height: rem(34);
  min-width: rem(50);
  padding: 0 rem(10);
  border: 1px solid #dfe8cf;
  border-radius: rem(17);
  background: rgba(255, 255, 255, 0.88);
  color: #587c22;
  font-size: rem(20);
  font-weight: bold;
  white-space: nowrap;
}

.light_toggle.active {
  border-color: #91bd49;
  background: #6e9f21;
  color: #fff;
}

.container_delete {
  border-color: #f0c4bd;
  background: rgba(255, 245, 243, 0.9);
  color: #cc4d3f;
}

.studio_container_tools {
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  padding-bottom: rem(1);

  &::-webkit-scrollbar {
    display: none;
  }
}

.container_button_group {
  display: flex;
  align-items: center;
  gap: rem(6);
}

.shadow_label {
  margin-left: rem(2);
}

.shadow_slider {
  flex: 0 0 rem(118);
  min-width: rem(96);
  margin-left: rem(2);
}
</style>
